import { useState } from 'react'

import { FormControlLabel, RadioGroup } from '@mui/material'

import { useSelector } from '@tabeeb/store'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Radio } from '@collaborate-health/uikit'
import { getFormTitle } from '@tabeeb/modules/appConfigState/selectors'

import { ExportFormsToCsvOptions } from '../../enums'

export interface ExportAsCsvDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (option: ExportFormsToCsvOptions) => void
}

const ExportAsCsvDialog: React.FC<ExportAsCsvDialogProps> = ({ open, onClose, onSubmit }) => {
  const formTitle = useSelector(getFormTitle)

  const [selectedOption, setSelectedOption] = useState<ExportFormsToCsvOptions>(ExportFormsToCsvOptions.All)

  return (
    <Dialog open={open} maxWidth='xs' fullWidth>
      <DialogTitle>Select data you would like to export</DialogTitle>
      <DialogContent>
        <RadioGroup
          value={selectedOption}
          onChange={(event) => {
            setSelectedOption(parseInt(event.target.value, 10))
          }}
        >
          {[
            {
              value: ExportFormsToCsvOptions.CurrentForm,
              name: `Current ${formTitle}`,
            },
            {
              value: ExportFormsToCsvOptions.All,
              name: 'All',
            },
          ].map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              label={option.name}
              control={<Radio color='primary' />}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            onSubmit(selectedOption)
            onClose()
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportAsCsvDialog

